import React from 'react';
import classNames from 'classnames';

class LazyImg extends React.Component {
    observer;
    didCancel = false;
    intersectionObserverSettings = {
        rootMargin: '500px 50px',
        threshold: [0, 0.25, 0.75, 1]
    };
    state = {
        loaded: false
    };

    componentDidMount() {
        const { src } = this.props;
        if (this.imageRef && !this.didCancel) {
            if (typeof IntersectionObserver !== 'undefined') {
                this.observer = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        // when image is visible in the viewport + rootMargin
                        if (!this.didCancel && (entry.intersectionRatio > 0 || entry.isIntersecting)) {
                            this.loadImage(src);
                            this.didCancel = true;
                        }
                    });
                }, this.intersectionObserverSettings);
                this.observer.observe(this.imageRef);
            } else {
                // Old browsers fallback
                this.loadImage(src);
            }
        }
    }

    componentWillUnMount() {
        if (this.observer && this.observer.unobserve) {
            this.observer.unobserve(this.imageRef);
        }
    }

    loadImage = (src) => {
        const { isBackground } = this.props;
        if (isBackground) {
            this.imageRef.style.backgroundImage = `url('${src}')`;
        } else {
            this.imageRef.src = src;
        }
    };

    onLoad = () => {
        this.setState(() => ({
            loaded: true
        }));
    }

    render() {
        const { isBackground, children, alt, className, role } = this.props;
        const imgClass = classNames(className,
            { 'lazy-img': !isBackground },
            { 'loaded': this.state.loaded }
        );

        if (isBackground) {
            return (
                <div
                    ref={(e) => this.imageRef = e}
                    className={imgClass}
                    role={alt && 'img'}
                    aria-label={alt}
                    title={alt}
                >
                    {children}
                </div>
            );
        }
        return (
            <img
                ref={(e) => this.imageRef = e}
                className={imgClass}
                alt={alt}
                onLoad={this.onLoad}
                role={role}
            />
        );
    }
}
export default LazyImg;



// WEBPACK FOOTER //
// ./components/lazy_img/index.jsx